import React from 'react';
import PropTypes from 'prop-types';
import FlexPublicationCard from './FlexPublicationCard';
import PublicationYearNav from './PublicationYearNav';

const PublicationListingView = ({
  items,
  show_author_links,
  show_year_navigation,
  compact,
  hide_link,
}) => {
  const showAuthorLinks = show_author_links !== false;
  const showYearNavigation = show_year_navigation !== false;
  return (
    <div className="view-wrapper publication-year-archive">
      {showYearNavigation && <PublicationYearNav position="top" />}
      <div className="cards__container">
        {items &&
          items.map((item) => (
            <FlexPublicationCard
              key={item['@id']}
              item={item}
              showAuthorLinks={showAuthorLinks}
              compact={compact}
              hideLink={hide_link}
            />
          ))}
      </div>
      {showYearNavigation && <PublicationYearNav position="bottom" />}
    </div>
  );
};

PublicationListingView.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  show_author_links: PropTypes.bool,
  show_year_navigation: PropTypes.bool,
  compact: PropTypes.bool,
  hide_link: PropTypes.bool,
};

export default PublicationListingView;
